export default {
  placeholders: {
    first_name: 'Nombre',
    last_name: 'Apellido',
    email: 'Email',
    mobile_number: 'Número de móvil',
  },
  labels: {
    exclusive_offers_via_email: 'Me gustaría recibir ofertas exclusivas y novedades por email.',
  },
  buttons: {
    sign_up: 'Regístrate',
  },
};
